import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Vehiculo } from '../interfaces/vehiculo.interface';

const base_url = `${ environment.base_url }/Vehiculos`;


@Injectable({
  providedIn: 'root'
})
export class VehiculosService {

  token:string = localStorage.getItem('tp-Token') || '';
  headers = new HttpHeaders({
    'Content-Type':'application/x-www-form-urlencoded',
    'Tp-Token': localStorage.getItem('tp-Token') || ''
  });

  constructor(private http: HttpClient) { }

  getCombo(orden:string){
    const url = `${ base_url }/getAll?&order=${orden}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  nuevo(data:Vehiculo){
    const url = `${ base_url }/postVehiculo`;
    // console.log(url);
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle, ultimoId: resp.totalPaginas};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  actualizar(data:Vehiculo){
    const url = `${ base_url }/putVehiculo/${data.id}`;
    // console.log(url);
    
    return this.http.put(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getVehiculosIdCliente(idCliente: number){
    const url = `${ base_url }/getVehiculosIdCliente/${idCliente}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getVehiculoCodigo(codigo:string){
    const url = `${ base_url }/getVehiculoCodigo/${codigo}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getVehiculoId(id:number){
    const url = `${ base_url }/getVehiculoId/${id}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  busqueda(valor:string, pagina:number, rows:number){
    const url = `${ base_url }/getBusquedaVehiculo/${valor}?page=${pagina}&rows=${rows}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getAll(pagina:number, rows:number, desdeCodigo:string, hastaCodigo:string, desdeNombre:string, hastaNombre:string, orden:string, desc:number){
    const url = `${ base_url }/getAll?page=${pagina}&rows=${rows}&decod=${desdeCodigo}&hacod=${hastaCodigo}&denom=${desdeNombre
                  }&hanom=${hastaNombre}&order=${orden}&desc=${desc}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  actualizarKMFichaVehiculo(idVehiculo: number, kms: number){
    const url = `${ base_url }/actualizarKMFichaVehiculo/${idVehiculo}/${kms}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

 
  async getDatos(matricula: string){
   const url = `https://api-matriculas-espana.p.rapidapi.com/es?plate=${matricula}`;
   // const url = `https://api-license-plate-spain-matricula-api-espana.p.rapidapi.com/?plaque=${matricula}`;
   const options = {
   	method: 'GET',
   	headers: {
   		'x-rapidapi-key': 'd14f50b871msh0414c9d7159c9d1p127345jsn52efa824cc1e',
   		// 'x-rapidapi-key': '931787ee7bmsh4810449815c76fap1a026fjsne5413d5a28b5',
   		// 'x-rapidapi-host': 'api-license-plate-spain-matricula-api-espana.p.rapidapi.com'
   		'x-rapidapi-host': 'api-matriculas-espana.p.rapidapi.com'
   	}
   };
   
   try {
   	const response = await fetch(url, options);
      const status = response.status;
      // if (!response.ok){
      //    // throw new Error('Error en la respuesta de la API');
      //    return { status, detalle: `Error en la respuesta (${status}): ${response.statusText}` };
      // }

      if (!response.ok) {
         // Intentar capturar el cuerpo del error si está disponible
         let errorDetail = `Error ${status}: ${response.statusText}`;
         try {
            const errorData = await response.json();
            if (errorData && typeof errorData === 'object') {
               errorDetail += ` - ${errorData.message || errorData.error || JSON.stringify(errorData)}`;
            }
         } catch {
            // Si no se puede parsear como JSON, mantenemos el statusText
         }
         return { status, detalle: errorDetail };
      }





      const data = await response.json();
   	// const result = await response.text();
   	// console.log(result);
      return  {status: 200, detalle: data}
   } catch (error) {
      console.error(error);
      return { status: 500, detalle: "Error al conectar con la API" };
   }
  }

}
